import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "invisible sr-only",
  "aria-hidden": "true"
}

import MainNavigationMobile from '@/shared/navigation/site-navigation/MainNavigationMobile.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePageSeoHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MainNavigationMobile)
  ]))
}
}

})